import { __extends } from "tslib";
import React from 'react';
import { Misc } from '@singularsystems/neo-core';
import { TooltipHelper } from './TooltipHelper';
export var containerId = "neo-toolip-container";
var TooltipInfo = /** @class */ (function () {
    function TooltipInfo(anchor, text, className) {
        this.anchor = anchor;
        this.text = text;
        this.className = className;
    }
    return TooltipInfo;
}());
/**
 * The tooltip provider creates a single tooltip div.
 * This div is shown when the mouse pointer moves over any element which has a data-tip attribute.
 * The text value of the data-tip attribute will be shown in the tooltip.
 * Other properties are:
 * - data-tip-class: adds a class name.
 * - data-tip-html: specifies that the string value of data-tip should be rendered as html.
 * - data-tip-align: center by default, or start / end / start-edge / end-edge.
 * - data-tip-pos: top by default (if there is enough space). Can be set to bottom / left / right.
 */
var TooltipProvider = /** @class */ (function (_super) {
    __extends(TooltipProvider, _super);
    function TooltipProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.observer = new MutationObserver(_this.onAttributesChanged.bind(_this));
        _this.lastElement = null;
        _this.domRef = React.createRef();
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.afterTransitioned = _this.afterTransitioned.bind(_this);
        _this.timerTick = _this.timerTick.bind(_this);
        return _this;
    }
    TooltipProvider.prototype.componentDidMount = function () {
        Misc.Globals.root.addEventListener("pointermove", this.onMouseMove);
        Misc.Globals.root.addEventListener("touchstart", this.onMouseMove);
        this.domRef.current.addEventListener("transitionend", this.afterTransitioned);
    };
    TooltipProvider.prototype.componentWillUnmount = function () {
        Misc.Globals.root.removeEventListener("pointermove", this.onMouseMove);
        Misc.Globals.root.removeEventListener("touchstart", this.onMouseMove);
        this.domRef.current.removeEventListener("transitionend", this.afterTransitioned);
        this.observer.disconnect();
    };
    TooltipProvider.prototype.onAttributesChanged = function (mutations) {
        this.showHideOnElement(this.currentInfo.anchor);
    };
    TooltipProvider.prototype.onMouseMove = function (e) {
        if (!this.lastElement || e.target !== this.lastElement) {
            this.lastElement = e.target;
            this.showHideOnElement(e.target);
        }
    };
    TooltipProvider.prototype.showHideOnElement = function (element) {
        var anchor = element;
        var toolTip = anchor.dataset["tip"];
        var tryCount = 0;
        while (!toolTip && tryCount < 8 && anchor) {
            anchor = anchor.parentElement;
            toolTip = anchor && anchor.dataset["tip"];
            tryCount++;
        }
        if (toolTip && anchor) {
            if (!this.currentInfo || this.currentInfo.anchor !== anchor || this.currentInfo.text !== toolTip) {
                this.currentInfo = new TooltipInfo(anchor, toolTip, anchor.dataset["tipClass"] || "");
                this.show(this.currentInfo);
            }
        }
        else if (this.currentInfo) {
            this.hide();
        }
    };
    TooltipProvider.prototype.afterTransitioned = function () {
        var toolTip = this.domRef.current;
        if (toolTip && !toolTip.classList.contains("show")) {
            toolTip.firstChild.innerText = "";
            toolTip.style.left = "-1000px";
        }
    };
    TooltipProvider.prototype.timerTick = function () {
        if (this.currentInfo) {
            if (!this.currentInfo.anchor.offsetHeight) {
                this.hide();
            }
        }
    };
    TooltipProvider.prototype.hide = function () {
        this.observer.disconnect();
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        TooltipHelper.hideTooltip();
        this.currentInfo = undefined;
    };
    TooltipProvider.prototype.show = function (info) {
        this.observer.observe(info.anchor, { childList: false, subtree: false, attributes: true, attributeFilter: ["data-tip", "data-tip-class"] });
        if (!this.timer) {
            this.timer = setInterval(this.timerTick, 500);
        }
        TooltipHelper.showTooltip(info.anchor, info.text, info.anchor.dataset["tipHtml"] === "true", info.anchor.dataset["tipAlign"], info.anchor.dataset["tipPos"], info.className);
    };
    TooltipProvider.prototype.render = function () {
        return (React.createElement("div", { ref: this.domRef, className: "neo-tooltip", id: containerId },
            React.createElement("div", { className: "neo-tooltip-text" }),
            React.createElement("div", { className: "neo-tooltip-arrow" })));
    };
    return TooltipProvider;
}(React.Component));
export default TooltipProvider;
